import { logEvent } from 'firebase/analytics';

import { initializeFirebaseAnalytics, getFirebaseAnalytics } from '@/lib/firebase/analytics';

function hashString(value: string): string {
  let hash = 0x811c9dc5;

  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index);
    hash = Math.imul(hash, 0x01000193);
  }

  return (hash >>> 0).toString(16).padStart(8, '0');
}

function normalizeAnalyticsSegment(value: string): string {
  return value
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '');
}

export function buildAnalyticsEventName(label: string, scope: string, prefix = 'btn'): string {
  const normalizedLabel = normalizeAnalyticsSegment(label) || 'action';
  const hash = hashString(`${scope}|${label}`);
  const maxLabelLength = Math.max(1, 40 - prefix.length - hash.length - 2);
  const trimmedLabel = normalizedLabel.slice(0, maxLabelLength);

  return `${prefix}_${trimmedLabel}_${hash}`;
}

export function trackAnalyticsEvent(eventName: string): void {
  if (typeof window === 'undefined') {
    return;
  }

  const analytics = getFirebaseAnalytics();

  if (analytics) {
    try {
      logEvent(analytics, eventName);
    } catch {
      // Analytics must never break the interaction flow.
    }

    return;
  }

  void initializeFirebaseAnalytics()
    .then((resolvedAnalytics) => {
      if (!resolvedAnalytics) {
        return;
      }

      try {
        logEvent(resolvedAnalytics, eventName);
      } catch {
        // Analytics must never break the interaction flow.
      }
    })
    .catch(() => undefined);
}
